import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { ToasterService } from '../services/toaster.service';
import { config } from '../config';
import { environment } from 'src/environments/environment';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-motor-go-digit-transaction-response',
  templateUrl: './motor-go-digit-transaction-response.component.html',
  styleUrls: ['./motor-go-digit-transaction-response.component.css'],
  providers: [ToasterService]
})
export class MotorGoDigitTransactionResponseComponent implements OnInit {
  godigitTransactionSuccessSection : boolean;
  godigitTransactionFailureSection : boolean;
  loading : boolean;
  txnId: string;
  applicationId: string;
  error: string;
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private router: ActivatedRoute, public toasterService: ToasterService, private serviceURLService: serviceURLService) { }

  ngOnInit() {
    this.router.queryParams.subscribe(params => {
      console.log(params);
      if(params.status == "SUCCESS"){
        this.txnId = params.txnId;
        this.applicationId = params.applicationId;
        this.godigitTransactionSuccessSection = true;
      }else{
        this.godigitTransactionFailureSection = true;
      }
    });
  }

  downloadPdf(){
  //  var url =  environment.msUrl + config.motorGoDigitdownloadPDF;
  //  window.open(url);
  this.loading = true;
  this.serviceURLService.downloadGoDigitResponsePdf(this.applicationId).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
    var pdfPath = successData.data.schedulePath;
    window.open(pdfPath)
    
    this.loading = false;
  }, errorData => {
    console.log("Oops..!! there is some error in prospect creation");
    this.error = errorData.error.message;
    this.toasterService.showErrorToaster(this.error);
    if(errorData.error.status === 403){
      this.error = errorData.error.message;
    }
  })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }

}
